import "core-js/modules/es.string.sub.js";
import exactMath from 'exact-math';
export var sumForTotalCell = function sumForTotalCell(val1, val2) {
  var sumValue = exactMath.add(val1 !== null && val1 !== void 0 ? val1 : 0, val2 !== null && val2 !== void 0 ? val2 : 0);
  return sumValue === 0 ? '0.00' : sumValue;
};
export var subForTotalCell = function subForTotalCell(val1, val2) {
  var sumValue = exactMath.sub(val1 !== null && val1 !== void 0 ? val1 : 0, val2 !== null && val2 !== void 0 ? val2 : 0);
  return sumValue === 0 ? '0' : sumValue;
};